import { router } from '@inertiajs/react'

interface MeetingPaginationProps {
  basePath: string
  filters: Record<string, string>
  page: number
  totalCount: number
  perPage: number
}

export default function MeetingPagination({ basePath, filters, page, totalCount, perPage }: MeetingPaginationProps) {
  const totalPages = Math.ceil(totalCount / perPage)
  if (totalPages <= 1) return null

  const hasNextPage = page < totalPages
  const hasPrevPage = page > 1

  const goToPage = (newPage: number) => {
    const params: Record<string, string> = {}
    Object.entries(filters).forEach(([k, v]) => {
      if (v && v !== 'all') params[k] = v
    })
    if (newPage > 1) params.page = String(newPage)
    router.get(basePath, params, { preserveState: true, preserveScroll: true, replace: true })
  }

  const btnClass = "px-3 py-1.5 text-sm border border-stone/30 rounded-lg bg-white text-text-primary hover:bg-[#F5F5F5] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"

  return (
    <div className="mt-6 flex items-center justify-between">
      <span className="text-sm text-text-muted">
        Page {page} of {totalPages}
      </span>
      <div className="flex items-center gap-2">
        <button
          onClick={() => goToPage(page - 1)}
          disabled={!hasPrevPage}
          className={btnClass}
        >
          &larr; Previous
        </button>
        <button
          onClick={() => goToPage(page + 1)}
          disabled={!hasNextPage}
          className={btnClass}
        >
          Next &rarr;
        </button>
      </div>
    </div>
  )
}
